export type CreditCardEventListeners = {
  handleStatusEvent: (event: CustomEvent) => void
  handlePaymentMethodEvent: (event: CustomEvent) => void
  handlePopupClosedEvent: EventListener
}

export function detachCreditCardEventListeners(
  element: EventTarget | null,
  listeners: CreditCardEventListeners
) {
  if (!element) return

  element.removeEventListener('cc:status', listeners.handleStatusEvent as EventListener)
  element.removeEventListener('cc:payment-method', listeners.handlePaymentMethodEvent as EventListener)
  element.removeEventListener('cc:popup-closed', listeners.handlePopupClosedEvent)
}

export function attachCreditCardEventListeners(
  previousElement: EventTarget | null,
  nextElement: EventTarget | null,
  listeners: CreditCardEventListeners
) {
  if (!nextElement) return previousElement
  if (previousElement === nextElement) return previousElement

  detachCreditCardEventListeners(previousElement, listeners)

  nextElement.addEventListener('cc:status', listeners.handleStatusEvent as EventListener)
  nextElement.addEventListener('cc:payment-method', listeners.handlePaymentMethodEvent as EventListener)
  nextElement.addEventListener('cc:popup-closed', listeners.handlePopupClosedEvent)

  return nextElement
}
